var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "select",
    {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.purposeFilter,
          expression: "purposeFilter"
        }
      ],
      staticClass: "sidebar-selectlist",
      on: {
        change: function change($event) {
          var $$selectedVal = Array.prototype.filter
            .call($event.target.options, function(o) {
              return o.selected
            })
            .map(function(o) {
              var val = "_value" in o ? o._value : o.value
              return val
            })
          _vm.purposeFilter = $event.target.multiple
            ? $$selectedVal
            : $$selectedVal[0]
        }
      }
    },
    [
      _c(
        "option",
        {
          attrs: {
            value: "all"
          }
        },
        [_c("translate", [_vm._v("alle")])],
        1
      ),
      _vm._v(" "),
      _c(
        "option",
        {
          attrs: {
            value: "content"
          }
        },
        [_c("translate", [_vm._v("Inhalt")])],
        1
      ),
      _vm._v(" "),
      _c(
        "option",
        {
          attrs: {
            value: "template"
          }
        },
        [_c("translate", [_vm._v("Aufgabenvorlage")])],
        1
      ),
      _vm._v(" "),
      _c(
        "option",
        {
          attrs: {
            value: "oer"
          }
        },
        [_c("translate", [_vm._v("OER-Material")])],
        1
      ),
      _vm._v(" "),
      _c(
        "option",
        {
          attrs: {
            value: "portfolio"
          }
        },
        [_c("translate", [_vm._v("ePortfolio")])],
        1
      ),
      _vm._v(" "),
      _c(
        "option",
        {
          attrs: {
            value: "draft"
          }
        },
        [_c("translate", [_vm._v("Entwurf")])],
        1
      ),
      _vm._v(" "),
      _c(
        "option",
        {
          attrs: {
            value: "other"
          }
        },
        [_c("translate", [_vm._v("Sonstiges")])],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }